module.exports = __webpack_public_path__ + "img/main-section-cover.e9624653.png";